<template>
  <v-btn
    small
    tile
    outlined
    depressed
    color="primary"
    dark
    @click="goToNewBatch"
    ><v-icon small color="primary">mdi-plus</v-icon>New Check</v-btn
  >
</template>
<script>
export default {
  methods: {
    goToNewBatch() {
      this.$router.push({ name: "NewBatch" });
    },
  },
};
</script>
